import React from 'react';
import PhoneNumberCard from './PhoneNumberCard';

const Step3_PhoneNumberSelection = ({
  phoneNumbers,
  selectedPhoneNumber,
  onPhoneNumberSelect,
  onBack,
  loading,
  error,
  wabaId,
  clinicId
}) => {
  return (
    <div className="text-center">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Step 3: Select Your Phone Number</h2>
        <p className="text-gray-600 mb-6">
          Choose the phone number you'd like to use for your WhatsApp Business Account.
        </p>
      </div>

      {phoneNumbers.length > 0 ? (
        <div className="max-w-2xl mx-auto">
          <div className="grid gap-4 mb-6">
            {phoneNumbers.map((phoneNumber) => (
              <PhoneNumberCard
                key={phoneNumber.id}
                phoneNumber={phoneNumber}
                isSelected={selectedPhoneNumber === phoneNumber.id}
                onSelect={onPhoneNumberSelect}
              />
            ))}
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              {error}
            </div>
          )}

          <div className="flex gap-4 justify-center">
            <button
              onClick={onBack}
              className="px-6 py-3 border border-gray-300 rounded-lg font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Back
            </button>
            <button
              onClick={() => onPhoneNumberSelect(selectedPhoneNumber)}
              disabled={loading || !selectedPhoneNumber}
              className={`px-6 py-3 rounded-lg font-semibold text-white transition-colors ${
                loading || !selectedPhoneNumber
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-[#075e54] hover:bg-[#054d44]'
              }`}
            >
              Continue
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <div className="text-gray-500 mb-4">No phone numbers found for this WABA ID.</div>
          <button
            onClick={onBack}
            className="px-6 py-3 border border-gray-300 rounded-lg font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Try Again
          </button>
        </div>
      )}
    </div>
  );
};

export default Step3_PhoneNumberSelection;
